import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { postPartidaCategory } from "../../../api/partidaCategory";
import { alertError, alertSuccess } from "../../../utils/logger";

const CreatePartidaSubcategoryDialog = ({ open, setOpen, parentCategory, onCreated }) => {
  const [descripcion, setDescripcion] = useState("");
  const [referencia, setReferencia] = useState("");
  const loggedUser = useSelector((store) => store.authentication?.user, shallowEqual);

  useEffect(() => {
    if (open) {
      setDescripcion("");
      setReferencia("");
    }
  }, [open]);

  const save = async () => {
    if (!descripcion.trim()) {
      alertError({ error: "La descripción es obligatoria." });
      return;
    }

    try {
      const response = await postPartidaCategory(
        {
          descripcion: descripcion.trim(),
          referencia: referencia.trim() || null,
          categoria_padre_id: parentCategory?.id,
        },
        loggedUser?.accessToken
      );
      if (response.status === 201 || response.status === 200) {
        alertSuccess({ title: "¡Guardada!", customMessage: "Subcategoría creada con éxito." });
        if (onCreated) {
          onCreated(response.data);
        }
        setOpen(false);
      }
    } catch (error) {
      alertError({ error, customMessage: "No se ha podido crear la subcategoría." });
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={Boolean(open)} onClose={() => setOpen(false)} className="backdrop">
      <DialogTitle>Nueva subcategoría</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Categoría padre"
          value={parentCategory?.descripcion || ""}
          InputLabelProps={{ shrink: true }}
          InputProps={{ readOnly: true }}
          margin="normal"
          variant="outlined"
        />
        <TextField
          autoFocus
          fullWidth
          required
          label="Descripción"
          value={descripcion}
          onChange={(event) => setDescripcion(event.target.value)}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
        />
        <TextField
          fullWidth
          label="Referencia"
          value={referencia}
          onChange={(event) => setReferencia(event.target.value)}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="outlined">Cancelar</Button>
        <Button onClick={save} color="primary" variant="outlined">Guardar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePartidaSubcategoryDialog;
